import { animate, useMotionValue, useTransform, motion } from 'framer-motion';
import formatCurrency from 'Helper/formatCurrency';
import formatNumber from 'Helper/formatNumber';
import { useEffect } from 'react';

const CountUpNumber = ({ end = 0, duration = 2, isLoading = false, uom = '', variant = '' }) => {
  const countProgress = useMotionValue(0);

  const rounded = useTransform(() => {
    switch (variant) {
      case 'currency':
        return formatCurrency(countProgress.get());
      default:
        return `${formatNumber(countProgress.get())}${uom}`;
    }
  });

  useEffect(() => {
    if (!isLoading) {
      const controls = animate(countProgress, Number(end), { duration: duration });
      return () => controls.stop();
    }
  }, [countProgress, duration, end, isLoading]);

  return <motion.span>{rounded}</motion.span>;
};

export default CountUpNumber;
